import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
// This no check will need to be removed at some point
// It is in to prevent build errors to do with the Dropdown type
// not containing detail and element props
// @ts-nocheck
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect, } from "react-router-dom";
import { Navigation, Callback, PageNotFound } from "./nav";
import { getTokenFromLocalStorage, getUserFromLocalStorage, tokenHasExpired, } from "./services/localStorage/localStorageService";
import { confirmAuthorised, getElementDependingOnAuthStatus, } from "./services/auth/authService";
import { AuthProvider } from "./contexts/auth.context";
import Footer from "./general/Footer";
import { convertToPath, matomoAnalytics } from "./general/utils";
import { env } from "./variables/config";
import { MyBoards, Board } from "./boards";
function TolApp(props) {
    const { boards, customCallbackUrl } = props;
    const [token, setToken] = useState(getTokenFromLocalStorage);
    const [user, setUser] = useState(getUserFromLocalStorage);
    useEffect(() => {
        const siteId = env.MATOMO_SITE_ID;
        matomoAnalytics(siteId);
    }, []);
    // show login button as default
    const login = props.login ?? true;
    // hide register button by default
    const register = props.register || false;
    if (!("API_PATH" in env)) {
        return (_jsx("div", { children: _jsx("h3", { children: "Please add 'API_PATH' as an environment variable (e.g. API_PATH=/api/v1)." }) }));
    }
    // dealing with pages
    let profilePages = props.profilePages;
    if (boards) {
        profilePages = [
            {
                name: "My Boards",
                element: _jsx(MyBoards, {}),
                auth: true,
            },
            ...(profilePages ?? []),
        ];
    }
    const allPages = [...props.pages, ...(profilePages ?? [])];
    const loggedIn = user && !tokenHasExpired();
    return (_jsx("div", { id: "tol-app-background", children: _jsx(AuthProvider, { value: {
                token,
                setToken,
                user,
                setUser,
            }, children: _jsxs(Router, { children: [_jsx(Navigation, { brand: props.brand, pages: props.pages, profilePages: profilePages, login: login, register: register, customCallbackUrl: customCallbackUrl }), _jsx("div", { className: "tol-app", children: _jsxs(Switch, { children: [_jsx(Route, { path: "/", exact: true, component: () => props.homePage }), _jsx(Route, { path: "/callback", exact: true, children: _jsx(Callback, {}) }), _jsx(Route, { path: "/board/:boardId", children: boards && loggedIn ? (_jsx(Board, { dataUrl: boards.dataUrl })) : (_jsx(Redirect, { to: "/" })) }), _jsx(Route, { path: "/board/:boardId/view/:viewId", children: boards && loggedIn ? _jsx(Board, {}) : _jsx(Redirect, { to: "/" }) }), allPages.map((page) => {
                                    const path = convertToPath(page.name);
                                    const routes = [];
                                    const authorised = confirmAuthorised(user, page.auth, page.removeOnAuth);
                                    // dropdown routes
                                    if (page.pages) {
                                        page.pages.forEach((dropdownPage) => {
                                            const dropdownPath = convertToPath(page.name) +
                                                convertToPath(dropdownPage.name);
                                            // dropdown page route
                                            routes.push(_jsx(Route, { exact: true, path: dropdownPath, children: authorised ? (getElementDependingOnAuthStatus(loggedIn, dropdownPage)) : (_jsx(Redirect, { to: "/" })) }, dropdownPath));
                                            // dropdown detail page route
                                            if (dropdownPage.detail) {
                                                routes.push(_jsx(Route, { exact: true, path: `${dropdownPath}/:id`, children: authorised ? (dropdownPage.detail) : (_jsx(Redirect, { to: "/" })) }, `${dropdownPath}-detail`));
                                            }
                                        });
                                    }
                                    else {
                                        // regular page route
                                        routes.push(_jsx(Route, { exact: true, path: path, children: authorised ? (getElementDependingOnAuthStatus(loggedIn, page)) : (_jsx(Redirect, { to: "/" })) }, page.name));
                                        // detail page route
                                        if (page.detail) {
                                            routes.push(_jsx(Route, { exact: true, path: `${path}/:id`, children: authorised ? page.detail : _jsx(Redirect, { to: "/" }) }, `${page.name}-detail`));
                                        }
                                    }
                                    return routes;
                                }), _jsx(Route, { path: "/page-not-found", component: () => _jsx(PageNotFound, {}) }), _jsx(Route, { path: "*", children: _jsx(Redirect, { to: "/page-not-found" }) })] }) }), _jsx(Footer, {})] }) }) }));
}
export default TolApp;
